var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.0534 2.8864C7.8348 2.105 8.89461 1.66602 9.99967 1.66602C11.1047 1.66602 12.1646 2.105 12.946 2.8864C13.7274 3.66781 14.1663 4.72761 14.1663 5.83268C14.1663 6.93775 13.7274 7.99756 12.946 8.77896C12.1646 9.56036 11.1047 9.99935 9.99967 9.99935C8.89461 9.99935 7.8348 9.56036 7.0534 8.77896C6.27199 7.99756 5.83301 6.93775 5.83301 5.83268C5.83301 4.72761 6.27199 3.66781 7.0534 2.8864ZM9.99967 3.33268C9.33663 3.33268 8.70075 3.59607 8.23191 4.06492C7.76307 4.53376 7.49967 5.16964 7.49967 5.83268C7.49967 6.49572 7.76307 7.13161 8.23191 7.60045C8.70075 8.06929 9.33663 8.33268 9.99967 8.33268C10.6627 8.33268 11.2986 8.06929 11.7674 7.60045C12.2363 7.13161 12.4997 6.49572 12.4997 5.83268C12.4997 5.16964 12.2363 4.53376 11.7674 4.06492C11.2986 3.59607 10.6627 3.33268 9.99967 3.33268Z",
    fill: "#A3A3A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33366 13.3327C7.67062 13.3327 7.03473 13.5961 6.56589 14.0649C6.09705 14.5338 5.83366 15.1696 5.83366 15.8327V17.4993C5.83366 17.9596 5.46056 18.3327 5.00033 18.3327C4.54009 18.3327 4.16699 17.9596 4.16699 17.4993V15.8327C4.16699 14.7276 4.60598 13.6678 5.38738 12.8864C6.16878 12.105 7.22859 11.666 8.33366 11.666H11.667C12.7721 11.666 13.8319 12.105 14.6133 12.8864C15.3947 13.6678 15.8337 14.7276 15.8337 15.8327V17.4993C15.8337 17.9596 15.4606 18.3327 15.0003 18.3327C14.5401 18.3327 14.167 17.9596 14.167 17.4993V15.8327C14.167 15.1696 13.9036 14.5338 13.4348 14.0649C12.9659 13.5961 12.33 13.3327 11.667 13.3327H8.33366Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.c423112d08f53b6c325d5e8de7ef0555.svg";
export { ForwardRef as ReactComponent };